import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    accessToken: null,
    client: null,
    uid: null,
    user: {}
  },
  reducers: {
    setAuthData(state, action) {
      const { accessToken, client, uid, user } = action.payload;
      state.accessToken = accessToken;
      state.client = client;
      state.uid = uid;
      state.user = user;
    },
    clearAuthData(state) {
      state.accessToken = null;
      state.client = null;
      state.uid = null;
      state.user = {};
    }
  }
});

export const { setAuthData, clearAuthData } = authSlice.actions;

export default authSlice.reducer;
